import _ from "lodash";

const defaultDayConfig = {
    "weekday": {
        isOpen: true,
        openingHours: ["17:30", "20:00"],
        slots: [{
            start: "17:30",
            end: "20:00",
            minRosters: 1,
            maxRosters: 2,
        }]
    },
    "weekend": {
        isOpen: true,
        openingHours: ["12:00", "17:00"],
        slots: [{
                start: "12:00",
                end: "14:30",
                minRosters: 2,
                maxRosters: 2
            },
            {
                start: "14:30",
                end: "17:00",
                minRosters: 1,
                maxRosters: 2,
            }
        ]
    },
    "weekend1": {
        isOpen: true,
        openingHours: ["12:00", "17:00"],
        slots: [{
                start: "12:00",
                end: "14:30",
                minRosters: 1,
                maxRosters: 2
            },
            {
                start: "14:30",
                end: "17:00",
                minRosters: 1,
                maxRosters: 2,
            }
        ]
    },
    "weekend1secondHalf": {
        isOpen: true,
        openingHours: ["14:30", "17:00"],
        slots: [
            {
                start: "14:30",
                end: "17:00",
                minRosters: 1,
                maxRosters: 2,
            }
        ]
    }, "weekend1firstHalf": {
        isOpen: true,
        openingHours: ["12:00", "14:30"],
        slots: [
            {
                start: "12:00",
                end: "14:30",
                minRosters: 1,
                maxRosters: 2,
            }
        ]
    }, "fullDay": {
        isOpen: true,
        openingHours: ["12:00", "19:30"],
        slots: [
            {
                start: "12:00",
                end: "14:30",
                minRosters: 1,
                maxRosters: 2,
            }
        ,
            {
                start: "14:30",
                end: "17:00",
                minRosters: 1,
                maxRosters: 2,
            }
        ,
        
            {
                start: "17:00",
                end: "19:30",
                minRosters: 1,
                maxRosters: 2,
            }
        ]
    },"shortDay": {
        isOpen: true,
        openingHours: ["17:00", "19:00"],
        slots: [
            {
                start: "17:00",
                end: "19:00",
                minRosters: 1,
                maxRosters: 2,
            }      
        ]
    }


}


const RosterCalendar = (startDate, numberOfDays) => {

    const days = []

    for (let d = 0; d < numberOfDays; d++) {
        const dateRef = startDate.add(d, 'day');
        days.push(Day(dateRef))
    }

    const getDay = (date) => {
        return days.find(d => {
            const dd = d.date;
            if (dd.isSame(date, 'day')) {
                return true;
            } else {
                return false;
            }
        });
    }

    const insertRoster = (r) => {
        const rDate = new Date(r.date.seconds * 1000);
        const day = getDay(rDate);
        if (!day) {
            console.log("Error: Date ranges have gone awry"); // TODO proper error logging here

        } else {
            day.insertRoster(r);
        }
    }

    const removeRoster = (r) => {
        const rDate = new Date(r.date.seconds * 1000);
        getDay(rDate).removeRoster(r);
        console.log("DAY AFTER removeRoster", getDay(rDate));
    }


    const insertDayOverride = (o) => {
        const date = new Date(o.date.seconds * 1000);
        if (!getDay(date)) {
            console.log("Error: Date ranges have gone awry, cant get day for ", date); // TODO proper error logging here
        } else {
            getDay(date).insertDayOverride(o);
        }
        //console.log(getDay(date).isOpen());
    }

    const removeDayOverride = (o) => {
        const date = new Date(o.date.seconds * 1000);
        getDay(date).removeDayOverride(o);
    }


    const getDays = () => {
        return days;
    }

    return {
        insertRoster,
        removeRoster,
        insertDayOverride,
        removeDayOverride,
        getDays
    }

}

const Day = (date) => {

    let dayData;
    let unmatchedRosters = [];

    const dateObj = date;

    const insertRoster = (r) => {
        // Find roster
        console.log("Daydata before insertRoster", dayData);
        const slot = dayData.slots.find(i => i.start === r.start && i.end === r.end);
        if (slot) {
            if (!("rosters" in slot)) slot.rosters = []
            // Insert roster to slot
            if (slot.rosters.length < slot.maxRosters) {
                slot.rosters.push(r);
            } else {
                console.warn("Maximum number of rosters already registered for slot", r.start, "-", r.end);
                unmatchedRosters.push(r);
            }
        } else {
            console.warn("No matching slot found in day when adding roster. Roster:", r.start, "-", r.end, "Day slots:", dayData.slots.map(s => s.start + "-" + s.end));
            unmatchedRosters.push(r);
        }
    }


    const removeRoster = (r) => {
        const slot = dayData.slots.find(i => i.start === r.start && i.end === r.end);
        if (slot) {
            // Find the right roster in the list to remove
            slot.rosters = slot.rosters.filter(roster => roster.id !== r.id);
        } else {
            // Try removing from unmatched rosters
            const prevLength = unmatchedRosters.length;
            unmatchedRosters = unmatchedRosters.filter(roster => roster.id !== r.id);
            if (unmatchedRosters.length === prevLength) {
                console.warn("No matching slot or unmatched roster found when removing roster:", r);
            }
        }
    }

    const getSlots = () => {
        return [...dayData.slots]
    }

    const getAssignableSlots = () => {
        return dayData.slots.filter(slot => slot.rosters.length < slot.maxRosters);
    }

    const isSlotFull = (slot) => {
        return slot?.rosters?.length < slot?.maxRosters ? false : true;
    }

    const showAsOpen = (slot) => {
        return slot?.rosters?.length >= slot.minRosters;
    }

    const isSufficientlyBooked = () => {
        if (!isOpen()) {
            return false;
        }
        /* inspect all slots and ensure num rosters > min rosters */
        // console.log("isSufficientlyBooked", dayData.slots.find(slot => slot.rosters.length < slot.minRosters), dateObj);
        //return (!dayData.slots.find(slot => slot.rosters.length < slot.minRosters));
        return dayData.slots.some(slot => slot.rosters.length >= slot.minRosters);

    }

    const insertDayOverride = (override) => {
        //console.log("insertDayOverride ", override);

        // Collect all existing rosters (matched + unmatched) before changing slots
        const existingRosters = [];
        if (dayData && dayData.slots) {
            dayData.slots.forEach(s => {
                if (s.rosters) existingRosters.push(...s.rosters);
            });
        }
        existingRosters.push(...unmatchedRosters);
        unmatchedRosters = [];

        if ((override && override.template != null)) {
            console.log("We have a template to use: ", defaultDayConfig[override.template]);
            const templateData = _.cloneDeep(defaultDayConfig[override.template]);
            if (!templateData) throw Error("Template not found:", override.template);
            dayData = templateData;
            dayData.id = override.id;
        } else {
            dayData = override /* TODO: insert override data sanity check */
        }

        /* Insert some empty fields TODO: Accept empty fields?*/
        if (!("slots" in dayData)) dayData.slots = [];
        if (!("openingHours" in dayData)) dayData.openingHours = [];

        dayData.slots.forEach(s => {
            if (!("rosters" in s)) s.rosters = []
        })

        // Re-insert existing rosters into the new slot configuration
        existingRosters.forEach(r => insertRoster(r));

        console.log("insert override day data result: ", dayData);

    }

    const removeDayOverride = (data) => {
        console.log("removeDayOverride: ", data);
        setDefaultRosters();
    }


    const getOpeningHours = () => {
        console.log("Openinghours:", dayData.openingHours);
        return dayData.openingHours;
    }
    const getOpeningHoursString = () => {
        const slots = dayData.slots;

        // for slots where rosters are full, we can show the opening hours
        const fullSlots = slots.filter(slot => slot.rosters.length >= slot.minRosters).map(slot => ({"start": slot.start, "end": slot.end}));

        // if slots are adjacent, we can merge them
        const mergedSlots = [];
        let currentSlot = null;
        fullSlots.forEach(slot => {
            if (currentSlot === null) {
                currentSlot = slot;
            } else {
                if (currentSlot.end === slot.start) {
                    currentSlot.end = slot.end;
                } else {
                    mergedSlots.push(currentSlot);
                    currentSlot = slot;
                }
            }
        });
        if (currentSlot !== null) {
            mergedSlots.push(currentSlot);
        }

        // Create a string of the opening hours
        return mergedSlots.map(slot => slot.start + "-" + slot.end).join(", ");

       
    }

    const getAllRosters = () => {
        const allRosters = [];
        dayData.slots.forEach(s => s.rosters.forEach(r => allRosters.push(r)));
        return allRosters
    }

    const getUnmatchedRosters = () => {
        return [...unmatchedRosters];
    }

    const isOpen = () => {
        return dayData.isOpen;
    }

    const getClosedReason = () => {
        return dayData.reason;
    }

    const getId = () => {
        return dayData.id;
    }

    const setDefaultRosters = () => {
        const dayOfWeek = dateObj.day();
        //console.log("Setting default rosters for dayOfWeek ", dayOfWeek)
        if (dayOfWeek === 6 || dayOfWeek === 0) {
            dayData = _.cloneDeep(defaultDayConfig["weekend"]);
        } else {
            dayData = _.cloneDeep(defaultDayConfig["weekday"]);
        }

        dayData.slots.forEach(s => s.rosters = [])
        unmatchedRosters = [];
    }

    setDefaultRosters();

    return {
        isOpen,
        getClosedReason,
        date,
        getId,
        isSufficientlyBooked,
        getOpeningHours,
        getOpeningHoursString,
        insertRoster,
        insertDayOverride,
        removeRoster,
        removeDayOverride,
        getSlots,
        showAsOpen,
        getAllRosters,
        getUnmatchedRosters,
        isSlotFull,
        getAssignableSlots,
    }
}


export default RosterCalendar;